export default __webpack_public_path__ + "static/media/serzh.79ee6862.png";